import request from '@/utils/request'
const apiPath = '/sys/customerLevel'
const customerLevelApi = {
  /**
   * 新增【客户级别】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【客户级别】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 列表查询【客户级别】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee/list', { params: query })  //type 2:业务员 3:加盟商
  },
  /**
   * 查询【客户级别】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【客户级别】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【客户级别】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  getAllLevel(data) {
    return request.post(apiPath + '/getAllLevel', data, { isFormData: 1 })
  },
}
export default customerLevelApi
